import { render, staticRenderFns } from "./CmgAccountModalRewardsStore.vue?vue&type=template&id=3524f1dc&scoped=true&lang=pug&"
import script from "./cmg-account-modal-rewards-store.ts?vue&type=script&lang=ts&"
export * from "./cmg-account-modal-rewards-store.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAccountModalRewardsStore.vue?vue&type=style&index=0&id=3524f1dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524f1dc",
  null
  
)

export default component.exports